<template>
  <div>
    <exit-dialog v-model="exitDialog" />

    <title-row
      title="Főépület recepció"
      subtitle="Recepciós: Demo János"
      :breadcrumb-items="[
        {
          text: 'Recepció',
          to: { name: 'Reception' },
        },
      ]"
    >
    </title-row>

    <v-row>
      <v-col cols="12" md="6" lg="8">
        <v-card flat class="rounded-xl">
          <v-card-title>Épületben tartózkodó személyek</v-card-title>
          <v-card-text>
            <v-data-table
              :items="occupants"
              :headers="[
                { text: 'Név', value: 'name' },
                { text: 'Idő', value: 'entry_datetime' },
                { value: 'actions', align: 'end' },
              ]"
            >
              <template #[`item.name`]="{ item }">
                <span>{{ item.name }}</span>
                <span v-if="item.type === 'GUEST'" class="ml-1 text-caption">(vendég)</span>
              </template>

              <template #[`item.entry_datetime`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      {{ item.entry_datetime | moment('from') }}
                    </span>
                  </template>
                  {{ item.entry_datetime | moment('lll') }}
                </v-tooltip>
              </template>

              <template #[`item.actions`]="{ item }">
                <v-btn
                  small
                  text
                  fab
                  dark
                  depressed
                  color="primary"
                  class="rounded-xl"
                  title="Kiléptetés"
                  @click="exitDialog = item"
                >
                  <v-icon>mdi-exit-run</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="4">
        <v-card flat class="rounded-xl">
          <v-card-title>Bejárat</v-card-title>
          <v-card-text>
            <div id="lpr-overlay" class="relative overflow-hidden rounded-xl">
              <LiveFeedWebrtc stream-url="http://uninet-stream.sze.hu:8889/1896/" />
            </div>
            <v-btn block color="primary" class="mt-4 rounded-xl">
              <v-icon left>mdi-door-open</v-icon>
              AJtó nyitása
            </v-btn>
          </v-card-text>
        </v-card>

        <v-card flat class="mt-6 rounded-xl">
          <v-card-title>Lift</v-card-title>
          <v-card-text>
            <v-btn
              dark
              depressed
              block
              color="primary"
              class="mt-6 rounded-xl"
              title="Részletek"
            ><v-icon>mdi-elevator-passenger</v-icon>
              Lift hívása a földszintre
            </v-btn>
          </v-card-text>
        </v-card>

        <v-card flat class="rounded-xl mt-6">
          <v-card-title>Pótkártyák</v-card-title>
          <v-card-text>
            <v-btn block color="primary" class="mt-4 rounded-xl">
              <v-icon left>mdi-account-card</v-icon>
              Pótkártya kiállítása
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import LiveFeedWebrtc from '@/components/StreamPlayerWebRtc.vue';
import ExitDialog from '@/pages/occupants/ExitDialog.vue';

export default {
  name: 'Reception',

  components: {
    LiveFeedWebrtc,
    ExitDialog,
  },

  data() {
    return {
      exitDialog: false,
    };
  },

  asyncComputed: {
    occupants: {
      async get() {
        const response = await this.$http.get('occupants/list');
        return response.occupants;
      },
      default: [],
    },
  },
};
</script>
